/** 선택 입력 필드 에러 메시지 (최소 10자 · 최대 1000자) */
export const optionalCharError = (val: string): string | null => {
    if (val.length === 0) return null;
    if (val.length < 10) return '최소 10자 이상 작성해 주세요.';
    if (val.length > 1000) return '최대 1,000자까지 입력 가능합니다.';
    return null;
};

export const getPureTextLength = (html: string): number => {
    if (!html) return 0;
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        // 공백 문자 및 개행 등을 포함한 순수 텍스트
        return doc.body.textContent?.length || 0;
    } catch {
        return html.replace(/<[^>]*>/g, '').length;
    }
};

export const getImageCount = (html: string): number => {
    if (!html) return 0;
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.querySelectorAll('img').length;
    } catch {
        return (html.match(/<img[^>]*>/g) || []).length;
    }
};

export const creativeProcessError = (html: string): string | null => {
    if (!html) return null;
    const pureTextLen = getPureTextLength(html);
    const imgCount = getImageCount(html);

    if (pureTextLen === 0 && imgCount === 0) return null;

    if (pureTextLen > 0 && pureTextLen < 10) {
        return '텍스트는 최소 10자 이상 작성해 주세요.';
    }
    if (pureTextLen > 1000) {
        return '텍스트는 최대 1,000자까지 입력 가능합니다.';
    }
    if (imgCount > 3) {
        return '이미지는 최대 3장까지 첨부 가능합니다.';
    }
    return null;
};
